import React, { useState, useEffect } from "react";
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';

const Container = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    height: 100vh;
    background-color: #f0f2f5;
`;

const LoginCard = styled.div`
    background-color: white;
    padding: 3rem;
    border-radius: 12px;
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
    width: 100%;
    max-width: 420px;
    display: flex;
    flex-direction: column;
    align-items: center;
`;

const TitleImageContainer = styled.div`
    margin-bottom: 2rem;
    text-align: center;
`;

const TitleImage = styled.img`
    max-width: 200px;
    height: auto;
`;

const Title = styled.h2`
    margin-bottom: 2rem;
    color: #333;
    font-size: 1.5rem;
    font-weight: 600;
`;

const InputGroup = styled.div`
    width: 100%;
    margin-bottom: 1.5rem;
`;

const Label = styled.label`
    display: block;
    margin-bottom: 0.5rem;
    color: #666;
    font-size: 0.9rem;
    font-weight: 500;
`;

const StyledInput = styled.input`
    width: 100%;
    padding: 0.8rem 1rem;
    font-size: 1rem;
    border: 1px solid #ddd;
    border-radius: 8px;
    transition: border-color 0.2s, box-shadow 0.2s;
    box-sizing: border-box; /* Ensure padding doesn't affect width */

    &:focus {
        outline: none;
        border-color: #007bff;
        box-shadow: 0 0 0 3px rgba(0, 123, 255, 0.1);
    }
`;

const ButtonContainer = styled.div`
    width: 100%;
    margin-top: 1rem;
`;

const StyledButton = styled.button`
    width: 100%;
    background-color: #007bff;
    color: white;
    padding: 0.9rem;
    font-size: 1.1rem;
    font-weight: 600;
    border: none;
    border-radius: 8px;
    cursor: pointer;
    transition: background-color 0.2s, transform 0.1s;

    &:hover {
        background-color: #0056b3;
    }

    &:active {
        transform: translateY(1px);
    }
`;

function LoginPage(props) {
    const navigate = useNavigate();
    const [adminId, setAdminId] = useState("");
    const [adminPw, setPassword] = useState("");

    useEffect(() => {
        const token = localStorage.getItem("authToken");
        if (token) {
            axios.get('/api/auth/validate').then(res => {
                if (res.data.success) navigate("/dashboard", { replace: true });
            }).catch(() => {
                localStorage.clear();
            });
        }
    }, [navigate]);

    const getLoginInfo = async () => {
        if (!adminId || !adminPw) {
            alert("아이디와 비밀번호를 입력하세요");
            return;
        }

        try {
            const result = await axios.post('/api/auth/login', { id: adminId, pw: adminPw });

            if (result.data.success) {
                const { token, user } = result.data;
                localStorage.setItem("authToken", token);
                localStorage.setItem("loginId", user.id);
                localStorage.setItem("loginName", user.name);
                localStorage.setItem("loginAffiliation", user.affiliation || "");
                localStorage.setItem("loginPosition", user.position || "");
                localStorage.setItem("loginRole", user.role);
                if (user.permissions) {
                    localStorage.setItem("permissions", JSON.stringify(user.permissions));
                }

                axios.post('/Loginlog', { id: user.id }).catch(err => {
                    console.error('Login log failed:', err);
                });
                navigate("/dashboard");
            }
        } catch (error) {
            if (error.response && error.response.status === 401) {
                alert("아이디 또는 비밀번호를 확인하세요");
            } else {
                console.error("Login error:", error);
                alert("로그인 중 오류가 발생했습니다.");
            }
        }
    };

    const handleKeyDown = (e) => {
        if (e.key === 'Enter') {
            getLoginInfo();
        }
    };

    return (
        <Container>
            <LoginCard>
                <TitleImageContainer>
                    <TitleImage src="/title_icon.png" alt="Title" />
                </TitleImageContainer>
                <Title>관리자 로그인</Title>
                <InputGroup>
                    <Label htmlFor="adminId">아이디</Label>
                    <StyledInput
                        type="text"
                        id="adminId"
                        value={adminId}
                        onChange={e => setAdminId(e.target.value)}
                        onKeyDown={handleKeyDown}
                        placeholder="아이디를 입력하세요"
                    />
                </InputGroup>
                <InputGroup>
                    <Label htmlFor="adminPw">비밀번호</Label>
                    <StyledInput
                        type="password"
                        id="adminPw"
                        value={adminPw}
                        onChange={e => setPassword(e.target.value)}
                        onKeyDown={handleKeyDown}
                        placeholder="비밀번호를 입력하세요"
                    />
                </InputGroup>
                <ButtonContainer>
                    <StyledButton onClick={getLoginInfo}>로그인</StyledButton>
                </ButtonContainer>
            </LoginCard>
        </Container>
    )
}

export default LoginPage;
